package com.tovtalk.domain.entity

/**
 * Session info - one device login
 */
data class SessionInfo(
    val id: Int,
    val isHadran: Boolean,
    val kosherLevelId: Int?,
    val lastSeenAt: String,
    val deviceId: String?,
    val userAgent: String?,
    val isCurrent: Boolean = false
)
